export const UserAction = {
    MOBILE_REGISTRATION: 'MOBILE_REGISTRATION',
    FIXEDLINE_REGISTRATION: 'FIXEDLINE_REGISTRATION',
    COMPLAINT: 'COMPLAINT'
}
